import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { companyConfiguration } from 'api/company'
//stores
import { useCompanyStore } from 'stores/companyStore';
//helpers
import { addToFormData } from 'helpers';
//components
import Title from 'components/backoffice/texts/title';
import CompanyForm from 'components/backoffice/forms/companyForm';

const Configuration = () => {
  const company = useCompanyStore();
  const { loadMetaCompany } = company;
  const [loading, setLoading] = useState(false);
  const [backendErrors] = useState({})
  const { setTitle } = useOutletContext()

  const { t } = useTranslation(['backoffice']);

  useEffect(() => {
    setTitle(t('configuration'))
    return () => {
      setTitle('');
    };
  }, [setTitle, t]);

  const onSubmit = async (values) => {
    setLoading(true);
    const socialsNetworks = {};
    const appsURLs = {};
    if (values.facebook !== '') {
      socialsNetworks.facebook = values.facebook;
    }
    if (values.twitter !== '') {
      socialsNetworks.twitter = values.twitter;
    }
    if (values.instagram !== '') {
      socialsNetworks.instagram = values.instagram;
    }
    if (values.google_play !== '') {
      appsURLs.google_play = values.google_play;
    }
    if (values.app_store !== '') {
      appsURLs.app_store = values.app_store;
    }

    const {
      email: validateEmail = '',
      web_url: validateWebUrl = '',
      direccion: validateAddress = '',
      telefono: validatePhone = '',
      logo: validateLogo = company.logo,
      latitude: validateLatitude = '',
      longitude: validateLongitude = '',
      business_hours: validateBusinessHour = '',
      theme: validateTheme = '',
      home_url: validateHomeUrl = '',
      home_image: validateHomeImage = company.home_image,
    } = values;
    const formData = new FormData()

    const items = {
      email: validateEmail,
      web_url: validateWebUrl,
      direccion: validateAddress,
      telefono: validatePhone,
      logo: validateLogo,
      business_hours: validateBusinessHour,
      theme: validateTheme,
      redes_sociales: JSON.stringify(socialsNetworks),
      apps_urls: JSON.stringify(appsURLs),
      home_url: validateHomeUrl,
      home_image: validateHomeImage,
    }

    if (validateLatitude !== '') {
      items.latitude = validateLatitude;
    }

    if (validateLongitude !== '') {
      items.longitude = validateLongitude;
    }

    if (typeof values.logo === 'string' && values.logo.startsWith('http')) {
      try {
        const response = await fetch(values.logo);
        const blob = await response.blob();
        const file = new File([blob], 'image.jpg', { type: blob.type });
        items.logo = file;
      } catch (error) {
        console.error('Error al convertir la imagen:', error);
      }
    }

    if (typeof values.home_image === 'string' && values.home_image.startsWith('http')) {
      try {
        const response = await fetch(values.home_image);
        const blob = await response.blob();
        const file = new File([blob], 'home_image.jpg', { type: blob.type });
        items.home_image = file;
      } catch (error) {
        console.error('Error al convertir la imagen de home_image:', error);
      }
    }

    addToFormData(formData, items)

    try {
      const { data, status } = await companyConfiguration(company.id, formData);
      if (status === 200) {
        const savedData = {
          ...company,
          ...data
        }
        loadMetaCompany(savedData);
        toast.success(t('editadocorrectamente'));
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <div className="mt-2">
      <Title text={t('configuration')} />
      <CompanyForm
        loading={loading}
        isEditing={true}
        onSubmitForm={onSubmit}
        defaultValues={company}
        id={company.id}
        backendErrors={backendErrors}
        beforeTitle={t('configuration')}
      />
    </div>
  );
};

export default Configuration;
